import { useNavigate } from 'react-router-dom';
import Footer from '../../../components/Footer';
import { Layout } from '../../../components/layout';
import ButtonBack from '../../../components/ui/buttonBack';
import {
	choosePlatform,
	choosePlatformDomainName,
	choosePlatformName,
} from '../../../helpers/utils';

export const PrivacyPolicy = () => {
	const navigate = useNavigate();
	return (
		<Layout customBG="bg-background-dark" logoWhite>
			<div className="px-3.5 pt-7 pb-7 lg:max-w-screen-xl lg:mx-auto">
				<div className="items-center flex-row flex justify-between px-3.5 pt-10 pb-6 lg:flex-col lg:justify-start lg:items-start lg:gap-4">
					<ButtonBack classNameIcon="text-custom-white" />
					<p
						className={
							'text-xl font-semibold text-center font-bahnschrift text-custom-white lg:text-left' +
							(choosePlatform()
								? ' lg:text-white'
								: ' lg:text-primary')
						}
					>
						Política de Privacidade
					</p>
					<div></div>
				</div>

				<div className="text-sm text-left text-custom-gray4 font-bahnschrift lg:rounded-lg lg:bg-custom-gray2 lg:p-8">
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							1. Introdução: Compromisso com a Transparência e a
							Sua Privacidade
						</span>
					</p>
					<br />
					<br />
					Bem-vindo ao {choosePlatformName()}! É com grande satisfação
					que o recebemos em nossa plataforma. No{' '}
					{choosePlatformName()}, valorizamos a sua privacidade e
					estamos comprometidos em proteger seus dados pessoais de
					forma transparente e responsável. Esta Política de
					Privacidade, elaborada em conformidade com a Lei Geral de
					Proteção de Dados Pessoais (LGPD), Lei nº 13.709/2018, e a
					Lei nº 14.790/2023, tem como objetivo explicar de forma
					clara e detalhada como coletamos, utilizamos, compartilhamos
					e protegemos as suas informações.
					<br />
					<br />
					Acreditamos na importância de estabelecer uma relação de
					confiança com você. Por isso, queremos que se sinta seguro e
					informado sobre como lidamos com seus dados. Ao utilizar a
					Plataforma {choosePlatformName()} (site www.
					{choosePlatformName()}.com.br e aplicativo
					{choosePlatformName()}), você manifesta sua concordância com
					os termos e condições desta Política de Privacidade.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							2. Coleta de Dados Pessoais: Informações que
							Coletamos e Porquê:
						</span>
					</p>
					<br />
					<br />
					Para proporcionar a melhor experiência possível e garantir a
					segurança da nossa plataforma, coletamos diferentes tipos de
					informações. É importante ressaltar que apenas coletamos os
					dados estritamente necessários para as finalidades descritas
					nesta Política.
					<br />
					<br />
					Os dados que coletamos se dividem nas seguintes categorias:
					<br />
					Dados de Registro: Essenciais para a criação da sua conta e
					para que você possa utilizar os serviços do{' '}
					{choosePlatformName()}. A coleta desses dados está em
					conformidade com a Portaria nº 1231/2024 do Ministério da
					Fazenda.
					<br />
					<br />
					- Nome completo: Para identificá-lo e personalizar sua
					experiência.
					<br />
					- Nacionalidade: Para fins de cumprimento de requisitos
					legais e regulatórios.
					<br />
					- Data de nascimento: Para confirmar sua idade e
					elegibilidade para utilizar nossos serviços.
					<br />
					- Número do CPF: Para fins de identificação fiscal e
					prevenção de fraudes.
					<br />
					- Endereço de e-mail: Para comunicação, envio de
					notificações e recuperação de senha.
					<br />
					- Endereço completo: Para fins de correspondência e
					cumprimento de obrigações legais.
					<br />
					- Número de telefone: Para contato em caso de necessidade e
					autenticação de dois fatores.
					<br />
					- Cópia digitalizada de documento de identificação com foto:
					Para verificar sua identidade e garantir a segurança da
					plataforma.
					<br />
					- Dados de Autenticação: Utilizados para confirmar sua
					identidade e proteger sua conta contra acessos não
					autorizados.
					<br />
					- Reconhecimento facial com prova de vida: Uma medida de
					segurança adicional para evitar fraudes e garantir que a
					pessoa que está acessando a conta é realmente você.
					<br />
					- Dados de Pagamento: Coletados quando você realiza
					depósitos ou saques na plataforma, sempre com o objetivo de
					garantir a segurança e a rastreabilidade das transações
					financeiras.
					<br />- Nome completo: Para garantir a correspondência entre
					a conta {choosePlatformName()} e a conta bancária.
					<br />
					- Data de nascimento: Para confirmar sua identidade e
					prevenir fraudes.
					<br />
					- Informações bancárias (banco, agência, conta ou chave
					PIX): Para processar depósitos e saques de forma segura e
					eficiente.
					<br />
					- Dados de Utilização dos Serviços: Informações técnicas
					coletadas durante sua navegação na plataforma, que nos
					ajudam a entender como você utiliza nossos serviços e a
					aprimorar sua experiência.
					<br />
					- Informações de URL: Para entender quais páginas você
					visita e como você interage com a plataforma.
					<br />
					- Cookies: Pequenos arquivos de texto que armazenam
					informações no seu dispositivo para melhorar sua experiência
					de navegação e personalizar o conteúdo. (Veja mais detalhes
					na seção "Cookies")
					<br />
					- Endereço de IP: Para fins de segurança, diagnóstico de
					problemas técnicos e análise de dados geográficos.
					<br />
					- Tipo de dispositivo: Para otimizar a plataforma para
					diferentes dispositivos (computadores, smartphones,
					tablets).
					<br />
					- Identificações únicas do dispositivo: Para reconhecer seu
					dispositivo e personalizar sua experiência.
					<br />
					- Tipo de conexão de internet: Para entender como a
					velocidade da sua internet afeta sua experiência na
					plataforma.
					<br />
					- Provedor de rede: Para fins de diagnóstico de problemas
					técnicos e análise de dados geográficos.
					<br />
					- Desempenho da rede: Para monitorar a qualidade da sua
					conexão e garantir uma boa experiência na plataforma.
					<br />
					- Navegador: Para otimizar a plataforma para diferentes
					navegadores (Chrome, Firefox, Safari).
					<br />
					- Sistema operacional: Para adaptar a plataforma a
					diferentes sistemas operacionais (Windows, macOS, Android,
					iOS).
					<br />
					- Geolocalização: Para fins de segurança, prevenção de
					fraudes e cumprimento da legislação, conforme a Portaria nº
					722/2024 do Ministério da Fazenda.
					<br />- Dados de Usuários Visitantes: Informações coletadas
					de usuários que visitam o site do {choosePlatformName()},
					mesmo sem criar uma conta.
					<br />
					<br />
					Endereço IP, Tipo de navegador, Informações sobre o
					dispositivo, Geolocalização, Páginas visitadas, Duração da
					visita, Caminhos de visualização do site, Visualizações da
					página: Para fins de análise de tráfego, aprimoramento do
					site e personalização da experiência do usuário.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							3. Finalidades do Tratamento de Dados Pessoais: Como
							Utilizamos Seus Dados
						</span>
					</p>
					<br />
					<br />O {choosePlatformName()} utiliza seus dados pessoais
					com as seguintes finalidades:
					<br />
					<br />
					Prestação de Serviços:
					<br />- Oferecer, manter, desenvolver, aprimorar e expandir
					os serviços da plataforma {choosePlatformName()}.
					<br />
					- Divulgar resultados de campeonatos e outras informações
					relevantes.
					<br />
					- Personalizar sua experiência na plataforma de acordo com
					suas preferências.
					<br />
					<br />
					Comunicação Eficaz:
					<br />
					- Entrar em contato com você por e-mail, notificações no
					aplicativo ou outros canais de comunicação.
					<br />
					- Enviar mensagens sobre novidades, promoções, eventos e
					outros conteúdos relevantes.
					<br />
					- Responder às suas dúvidas e solicitações de suporte.
					<br />
					<br />
					Segurança Reforçada:
					<br />
					- Implementar e aprimorar medidas de segurança para proteger
					sua conta e seus dados.
					<br />
					- Prevenir fraudes, atividades suspeitas e acessos não
					autorizados.
					<br />
					- Garantir o cumprimento da legislação e regulamentações
					aplicáveis.
					<br />
					<br />
					Análise e Melhoria:
					<br />
					- Coletar dados estatísticos sobre o uso da plataforma para
					entender o comportamento dos usuários e melhorar nossos
					serviços.
					<br />
					- Realizar pesquisas e análises para desenvolver novas
					funcionalidades e aprimorar a experiência do usuário.
					<br />
					<br />
					Cumprimento Legal:
					<br />
					- Cumprir com obrigações legais e regulatórias, como as
					relacionadas à LGPD e à Lei nº 14.790/2023.
					<br />
					- Atender a solicitações de autoridades competentes.
					<br />
					- Proteger nossos direitos em eventuais litígios.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							4. Compartilhamento de Dados Pessoais: Com Quem
							Compartilhamos Seus Dados e Porquê:
						</span>
					</p>
					<br />
					<br />O {choosePlatformName()} se compromete a proteger a
					confidencialidade dos seus dados e a compartilhá-los apenas
					em situações específicas e com as devidas garantias de
					segurança:
					<br />
					<br />
					Mudanças na Estrutura do {choosePlatformName()}: Em caso de
					fusão, aquisição, venda de ativos ou qualquer outra mudança
					na estrutura societária do {choosePlatformName()}, seus
					dados poderão ser transferidos, sempre respeitando os termos
					desta Política de Privacidade e a legislação vigente.
					<br />
					<br />
					‍Seus dados poderão ser compartilhados com terceiros, para
					melhor execução e continuidade dos serviços fornecidos,
					conforme descrito abaixo:
					<br />
					<br />
					- Provedores de Serviços Confiáveis: Compartilhamos dados
					com empresas parceiras que nos auxiliam na prestação de
					serviços essenciais, como:
					<br />
					- Armazenamento em nuvem: Para garantir a segurança e a
					disponibilidade dos seus dados.
					<br />
					- Processamento de pagamentos: Para processar suas
					transações financeiras de forma segura e eficiente.
					<br />
					- Análise de dados: Para entender o comportamento dos
					usuários e melhorar nossos serviços.
					<br />
					- Marketing e comunicação: Para enviar mensagens relevantes
					e personalizadas.
					<br />
					- Suporte técnico: Para auxiliar na resolução de problemas e
					dúvidas.
					<br />
					<br />É importante destacar que esses provedores de serviços
					são cuidadosamente selecionados e obrigados a cumprir com
					rigorosos padrões de segurança e confidencialidade,
					utilizando seus dados apenas para as finalidades
					especificadas pelo {choosePlatformName()}.
					<br />
					<br />
					Em Caso de Disputas Legais: Em situações de conflitos ou
					litígios envolvendo o {choosePlatformName()}, poderemos
					utilizar seus dados para proteger nossos direitos e
					interesses legítimos, sempre em conformidade com a
					legislação aplicável.
					<br />
					<br />
					Por Determinação Legal: O {choosePlatformName()} poderá
					compartilhar seus dados para cumprir ordens judiciais ou
					administrativas emitidas por autoridades competentes, em
					estrito cumprimento da lei.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							5. Armazenamento de Dados Pessoais: Segurança e
							Proteção
						</span>
					</p>
					<br />A segurança dos seus dados é uma prioridade para o{' '}
					{choosePlatformName()}. Implementamos medidas de segurança
					robustas para proteger suas informações contra acessos não
					autorizados, uso indevido, divulgação, alteração ou
					destruição.
					<br />
					<br />
					- Tempo de Armazenamento: Seus dados pessoais são
					armazenados pelo tempo necessário para cumprir as
					finalidades para as quais foram coletados, em conformidade
					com a legislação aplicável e eventuais obrigações legais de
					retenção de dados.
					<br />
					- Armazenamento Seguro: Seus dados podem ser armazenados em
					servidores localizados no Brasil ou no exterior, inclusive
					em serviços de nuvem. Asseguramos que a transferência
					internacional de dados cumpre os requisitos da LGPD e da Lei
					nº 14.790/2023, com a adoção de medidas de segurança
					adequadas para proteger suas informações, como cláusulas
					contratuais específicas e avaliações de impacto à proteção
					de dados.
					<br />
					- Medidas de Segurança: Utilizamos uma variedade de
					tecnologias e procedimentos de segurança para proteger seus
					dados, incluindo:
					<br />
					- Criptografia: Codificamos seus dados para que eles sejam
					ilegíveis para pessoas não autorizadas.
					<br />
					- Controle de acesso: Restringimos o acesso aos seus dados
					apenas a pessoas autorizadas que precisam deles para
					realizar suas funções.
					<br />
					- Firewalls: Utilizamos firewalls para proteger nossos
					servidores contra acessos não autorizados.
					<br />
					- Monitoramento constante: Monitoramos nossos sistemas em
					tempo real para detectar e prevenir ameaças à segurança.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							6. Seus Direitos como Titular de Dados Pessoais:
							Controle e Transparência
						</span>
					</p>
					<br />
					<br />A LGPD garante a você uma série de direitos em relação
					aos seus dados pessoais. No {choosePlatformName()},
					respeitamos esses direitos e facilitamos o seu exercício:
					<br />
					<br />
					- Confirmação e Acesso: Você tem o direito de confirmar se
					estamos tratando seus dados pessoais e solicitar acesso às
					informações que mantemos sobre você.
					<br />
					- Correção: Caso seus dados estejam incompletos, inexatos ou
					desatualizados, você pode solicitar a correção.
					<br />
					- Anonimização, Bloqueio ou Eliminação: Você pode solicitar
					a anonimização, bloqueio ou eliminação dos seus dados caso
					eles sejam desnecessários, excessivos ou tratados em
					desconformidade com a LGPD.
					<br />- Portabilidade: Você tem o direito de solicitar a
					portabilidade dos seus dados a outro fornecedor de serviços,
					observados os segredos comercial e industrial do{' '}
					{choosePlatformName()}.
					<br />
					- Informação sobre Compartilhamento: Você pode solicitar
					informações sobre as entidades com as quais compartilhamos
					seus dados.
					<br />
					- Oposição: Você tem o direito de se opor ao tratamento dos
					seus dados caso o tratamento se baseie em uma das hipóteses
					de dispensa de consentimento previstas na LGPD e haja
					descumprimento à lei.
					<br />
					- Informação sobre Consentimento: Você tem o direito de ser
					informado sobre a possibilidade de não fornecer
					consentimento para o tratamento de seus dados e sobre as
					consequências da recusa.
					<br />
					- Revogação do Consentimento: Você pode revogar o
					consentimento que nos forneceu para o tratamento de seus
					dados, exceto nos casos em que o tratamento se baseie em
					outra base legal.
					<br />
					- Eliminação: Você pode solicitar a eliminação dos seus
					dados pessoais, exceto quando a lei exigir a sua
					conservação.
					<br />
					- Reclamação à ANPD: Você tem o direito de apresentar uma
					reclamação à Autoridade Nacional de Proteção de Dados (ANPD)
					caso acredite que seus direitos de proteção de dados foram
					violados.
					<br />
					<br />
					Para exercer qualquer um desses direitos, basta entrar em
					contato conosco através do nosso Canal da Transparência
					(veja a seção "Contato").
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							7. Cookies: Aprimorando Sua Experiência
						</span>
					</p>
					<br />
					Utilizamos cookies e tecnologias semelhantes para aprimorar
					sua experiência na Plataforma {choosePlatformName()}.
					Cookies são pequenos arquivos de texto que são armazenados
					no seu dispositivo quando você visita nosso site ou utiliza
					nosso aplicativo.
					<br />
					<br />
					Tipos de Cookies:
					<br />
					- Essenciais: Necessários para o funcionamento básico da
					plataforma, como permitir que você faça login na sua conta e
					navegue pelas páginas.
					<br />
					- De Desempenho: Coletam informações sobre como você utiliza
					a plataforma, como as páginas que você visita e os links em
					que clica. Esses cookies nos ajudam a melhorar a performance
					e o design da plataforma.
					<br />
					- De Funcionalidade: Permitem que a plataforma se lembre das
					suas preferências, como idioma, região e configurações de
					personalização.
					<br />
					- De Publicidade: Utilizados para exibir anúncios relevantes
					aos seus interesses.
					<br />
					- Gerenciando Cookies: Você pode controlar e gerenciar
					cookies através das configurações do seu navegador ou
					dispositivo. No entanto, a desativação de certos cookies
					pode afetar a funcionalidade da plataforma.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							8. Alterações nesta Política de Privacidade:
							Mantendo Você Informado
						</span>
					</p>
					<br />
					<br />O {choosePlatformName()} se reserva o direito de
					atualizar esta Política de Privacidade periodicamente, para
					refletir mudanças na legislação, em nossos serviços ou em
					nossas práticas de tratamento de dados. Você será notificado
					sobre quaisquer alterações significativas por e-mail ou
					através de avisos na plataforma. Ao continuar utilizando a
					Plataforma {choosePlatformName()} após a entrada em vigor
					das alterações, você estará concordando com os novos termos
					da Política de Privacidade.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							9. Contato: Estamos à Disposição
						</span>
					</p>
					<br />
					Em caso de dúvidas, solicitações ou comentários sobre esta
					Política de Privacidade ou sobre o tratamento dos seus dados
					pessoais, entre em contato conosco através do nosso Canal da
					Transparência, disponível no endereço eletrônico{' '}
					<span
						onClick={() => {
							navigate('/help');
						}}
						className="cursor-pointer font-bold"
					>
						www.{choosePlatformDomainName()}/help
					</span>
					. Nossa equipe terá prazer em atendê-lo.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							10. Responsabilidades: Compromisso com a Lei
						</span>
					</p>
					<br />O {choosePlatformName()} assume a responsabilidade
					pelo tratamento dos seus dados pessoais em conformidade com
					a LGPD e demais leis aplicáveis. Caso haja violação à
					legislação e você sofra algum dano em decorrência do
					tratamento inadequado dos seus dados, nos responsabilizamos
					pela reparação dos danos, nos limites da lei.
					<br />
					<br />
					<p className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
						<span className="h-6 text-base font-bold text-left text-custom-white font-bahnschrift">
							11. Canal de Contato - Encarregado de Proteção de
							Dados (DPO)
						</span>
					</p>
					<br />
					Em conformidade com o Art. 41 da Lei Geral de Proteção de
					Dados (LGPD)Lei.13.709-2018, a nossa empresa disponibiliza
					um canal exclusivo para comunicação com o Encarregado de
					Proteção de Dados (DPO) Dra Irati Aparecida Santos. Caso
					tenha dúvidas sobre o tratamento de seus dados pessoais ou
					queira exercer seus direitos previstos na LGPD, entre em
					contato conosco pelo e-mail:{' '}
					<a
						href={`mailto:iratis@${choosePlatformDomainName()}`}
						className="cursor-pointer font-bold"
					>
						{`iratis@${choosePlatformDomainName()}`}
					</a>
					<br />
					<br />
					Este canal está à disposição para garantir a transparência e
					a proteção dos seus dados pessoais.
					<br />
					<br />
					<span className="font-bold">
						{choosePlatformName()} - Sua privacidade é nossa
						prioridade.
					</span>
					<br />
					<br />
				</div>
			</div>

			<Footer />
		</Layout>
	);
};
